import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const CtrlSortGridIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M21 1.25H3C2.04 1.25 1.25 2.04 1.25 3V21C1.25 21.96 2.04 22.75 3 22.75H21C21.96 22.75 22.75 21.96 22.75 21V3C22.75 2.04 21.96 1.25 21 1.25ZM9.29 14.71V9.29H14.71V14.71H9.29ZM14.71 15.96V21.25H9.29V15.96H14.71ZM2.75 9.29H8.04V14.71H2.75V9.29ZM9.29 8.04V2.75H14.71V8.04H9.29ZM15.96 9.29H21.25V14.71H15.96V9.29ZM21.25 3V8.04H15.96V2.75H21C21.14 2.75 21.25 2.86 21.25 3ZM3 2.75H8.04V8.04H2.75V3C2.75 2.86 2.86 2.75 3 2.75ZM2.75 21V15.96H8.04V21.25H3C2.86 21.25 2.75 21.14 2.75 21ZM21 21.25H15.96V15.96H21.25V21C21.25 21.14 21.14 21.25 21 21.25Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

CtrlSortGridIcon.displayName = 'CtrlSortGridIcon';
